import React from 'react'
import './clients.css';
import SRM from '../../assets/srmplano.png';
import more_soon from '../../assets/more-soon.png';
import blooming_buds from '../../assets/blooming-buds.jpeg';

const Clients = () => {
  return (
    <section id="clients">
        <span className="clientTitle">My clients</span>
        <span className="clientPara">I have had the opportunity to work with these amazing organizations:</span>
        <div className="clientImgs">
            <img src={SRM} alt="SRM" className="clientImg" />
            <img src={blooming_buds} alt="bloomingbuds" className="clientImg" />
            <img src={more_soon} alt="morecomingsoon" className="clientImg" />
        </div>
    </section>
  )
}

export default Clients
